import React, { PureComponent, Fragment } from "react";
import { withRouter, Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Row,
  Col,
  Nav,
  NavLink,
  NavItem,
  TabContent,
  TabPane,
  Container,
} from "reactstrap";
import NewsItem from "./NewsItem";
import { _axiosCall, _buildingIDs } from "../../../shared/helpers/apicalls";
import moment from "moment";

import ButtonGroup from "@material-ui/core/ButtonGroup";

import LinearLoading from "../../../shared/components/LinearLoading";
import classnames from "classnames";
import classNames from "classnames";
import { makeStyles, withStyles } from "@material-ui/core/styles";

import { Tooltip, FormControlLabel, Switch } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import LoadMoreIcon from "mdi-react/RefreshIcon";
import LoadingIcon from "mdi-react/DotsHorizontalIcon";

import { Publisher } from "../../../shared/pubsub/publisher.js";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import searchActions from "../../../redux/actions/searchActions";

import BuildingSearchAppBar from "../../../shared/components/building_filters/UnitsSearchAppBar";

import AlertIcon from "mdi-react/InformationOutlineIcon";
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  mpndCohortQuery,
  pipelineCohortQuery,
  getCohortQuery,
  GenerateBuildingSlug,
  GenerateBuildingKey,
  _tranformTagsQuery,
} from "../../../shared/helpers/utils";

const PurpleSwitch = withStyles({
  switchBase: {
    color: "#780f9e",
    "&$checked": {
      color: "#780f9e",
    },
    "&$checked + $track": {
      backgroundColor: "#EDDEF5",
    },
  },
  checked: {},
  track: {
    backgroundColor: "#EDDEF5",
  },
})(Switch);

const apiURL = process.env.API_ROOT + "/query/";
const buildingUrl = process.env.API_ROOT + "/pipeline/";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "-8px",
    alignItems: "left",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  button: {
    "&.selected": {
      background: "#EDDEF5",
    },
  },
}));

// Sub-topic filter definitions per tab (based on mp-nav-v1 subfilters.js)
const SUB_TOPIC_FILTERS = {
  articles: [
    {
      name: "Publication",
      key: "publication",
      values: [
        { name: "All", filter: "" },
        { name: "New York Yimby", filter: "new-york-yimby" },
        { name: "The Real Deal", filter: "the-real-deal-new-york" },
        { name: "NY Times", filter: "nyt-greater-real-estate" },
        { name: "NY Post", filter: "real-estate-or-new-york-post" },
        { name: "Brownstoner", filter: "brownstoner" },
        { name: "Curbed NY", filter: "curbed-ny-all" },
        { name: "6sqft", filter: "6sqft" },
        { name: "Bisnow", filter: "bisnow-content-feed" },
        { name: "Commercial Observer", filter: "commercial-observer" },
        { name: "PincusCo", filter: "pincusco" },
      ],
    },
  ],
  construction: [
    {
      name: "Type",
      key: "permitType",
      values: [
        { name: "All", filter: "" },
        { name: "New Building", filter: "nb" },
        { name: "Major Alteration", filter: "a1" },
        { name: "Demolition", filter: "dm" },
      ],
    },
    {
      name: "Status",
      key: "permitStatus",
      values: [
        { name: "All", filter: "" },
        { name: "Permit Filed", filter: "permit-filing" },
        { name: "Permit Issued", filter: "permit-issuance" },
        { name: "Temp CO Issued", filter: "coo-temporary" },
        { name: "Final CO Issued", filter: "coo-final" },
      ],
    },
  ],
  "offering-plans": [
    {
      name: "Type",
      key: "offeringType",
      values: [
        { name: "All", filter: "" },
        { name: "New Condo", filter: "new-condo" },
        { name: "New Co-op", filter: "new-coop" },
        { name: "Condo Conversion", filter: "condo-conversion" },
        { name: "Co-op Conversion", filter: "coop-conversion" },
      ],
    },
    {
      name: "Status",
      key: "offeringStatus",
      values: [
        { name: "All", filter: "" },
        { name: "Submitted", filter: "submitted" },
        { name: "Accepted", filter: "accepted" },
        { name: "Effective", filter: "effective" },
        { name: "Rejected", filter: "rejected" },
        { name: "Withdrawn", filter: "withdrawn" },
      ],
    },
  ],
  listings: [
    {
      name: "Sale / Rent",
      key: "eventType",
      values: [
        { name: "All", filter: "" },
        { name: "For Sale", filter: "sale" },
        { name: "For Rent", filter: "rent" },
      ],
    },
  ],
  contracts: [
    {
      name: "Sale / Rent",
      key: "eventType",
      values: [
        { name: "All", filter: "" },
        { name: "For Sale", filter: "sale" },
        { name: "For Rent", filter: "rent" },
      ],
    },
  ],
  sales: [
    {
      name: "Sale / Rent",
      key: "eventType",
      values: [
        { name: "All", filter: "" },
        { name: "For Sale", filter: "sale" },
        { name: "For Rent", filter: "rent" },
      ],
    },
  ],
  "price-changes": [
    {
      name: "Direction",
      key: "changeType",
      values: [
        { name: "All", filter: "" },
        { name: "Price Drops", filter: "decrease" },
        { name: "Price Hikes", filter: "increase" },
      ],
    },
    {
      name: "Sale / Rent",
      key: "eventType",
      values: [
        { name: "All", filter: "" },
        { name: "For Sale", filter: "sale" },
        { name: "For Rent", filter: "rent" },
      ],
    },
  ],
};

const SubTopicFilters = ({
  activeTab,
  subFilters,
  setSubFilter,
  pipelineOnly,
  setPipelineOnly,
  buildingRes,
}) => {
  const classes = useStyles();
  const filterGroups = SUB_TOPIC_FILTERS[activeTab];

  return (
    <div className={"mt-3 mb-2"}>
      {filterGroups &&
        filterGroups.map((group, gi) => (
          <div
            key={group.key}
            style={{
              display: "inline-block",
              marginRight: 20,
              marginBottom: 8,
            }}
          >
            <span
              style={{
                fontSize: 12,
                color: "#858AA1",
                marginRight: 8,
                fontWeight: 500,
              }}
            >
              {group.name}:
            </span>
            <ButtonGroup size="small" aria-label={group.name}>
              {group.values.map((val) => (
                <Button
                  key={val.filter}
                  onClick={() => setSubFilter(group.key, val.filter)}
                  className={
                    (subFilters[group.key] || "") === val.filter
                      ? classNames(classes.button, "selected")
                      : classNames(classes.button)
                  }
                  size="small"
                >
                  {val.name}
                </Button>
              ))}
            </ButtonGroup>
          </div>
        ))}
      {!buildingRes && (
        <div style={{ display: "flex", alignItems: "center", marginTop: 4, marginBottom: 4, marginLeft: 20 }}>
          <span style={{ fontSize: 14, fontWeight: 400, color: "#171F26", marginRight: 12 }}>
            All News
          </span>
          <PurpleSwitch
            checked={pipelineOnly}
            onChange={(e) => setPipelineOnly(e.target.checked)}
            size="small"
          />
          <span style={{ fontSize: 14, fontWeight: 400, color: "#171F26", marginLeft: 12 }}>
            Pipeline Projects Only
          </span>
        </div>
      )}
      <hr style={{ marginTop: 8, marginBottom: 0 }} />
    </div>
  );
};

class TimelineHistory extends PureComponent {
  state = {
    rowsPerPage: 25,
    fetchInProgress: false,
    clearInput: false,
    start: 0,
    data: [],
    noMoreResults: false,
    activeTab:
      this.props.match && this.props.match.params.subtab
        ? this.props.match.params.subtab
        : "summary",
    buildingsFetchInProgress: false,
    buildingData: false,
    subFilters: {},
    pipelineOnly: true,
    prevSearchTags: [],
  };

  _getFqMap = () => {
    const { buildingRes } = this.props;

    return {
      summary: !buildingRes
        ? "(topic:(stories OR offeringplans OR coo)) OR (topic:permits AND event_tags:(nb a1))"
        : "(topic:(stories OR offeringplans OR coo OR listings OR transactions)) OR (topic:permits AND event_tags:(nb a1 dm))",
      articles: "topic:stories",
      construction:
        "topic:(offeringplans OR coo) OR (topic:permits AND event_tags:(nb a1))",
      "offering-plans": "topic:offeringplans",
      listings: !buildingRes
        ? "topic:listings AND event_tags:just-listed AND -event_tags:rent"
        : "topic:listings AND event_tags:just-listed",
      contracts:
        "topic:listings AND event_tags:contract-signed AND -event_tags:rent",
      sales: "topic:transactions",
      "price-changes": "event_tags:(price-decrease price-increase)",
    };
  };

  componentDidMount() {
    this._getNews();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.start !== prevState.start) {
      this._getNews();
    }
    if (
      this.state.activeTab !== prevState.activeTab ||
      this.state.pipelineOnly !== prevState.pipelineOnly ||
      JSON.stringify(this.state.subFilters) !==
        JSON.stringify(prevState.subFilters)
    ) {
      this._getNews(true);
    }
    // Check if searchTags changed
    const { searchTags } = this.props;
    const prevSearchTags = prevProps.searchTags;
    if (
      searchTags &&
      prevSearchTags &&
      JSON.stringify(searchTags) !== JSON.stringify(prevSearchTags)
    ) {
      this._getNews(true);
    }
  }

  _loadMore = () => {
    if (this.state.fetchInProgress === true) {
      return false;
    }
    this.setState({ start: this.state.start + this.state.rowsPerPage });
  };

  _setActiveTab(tab) {
    const { buildingRes } = this.props;
    const newURL = buildingRes
      ? _getBuildingURL(buildingRes, "_id") + (tab ? `/tab/news/${tab}` : "")
      : `/news/${tab}`;
    window.history && window.history.pushState({}, null, newURL);
    Publisher.publish(`track.NewsView.${tab}`, {});
    this.setState({ activeTab: tab, data: [], subFilters: {} });
  }

  _setSubFilter = (key, value) => {
    this.setState((prevState) => ({
      subFilters: { ...prevState.subFilters, [key]: value },
    }));
  };

  _setPipelineOnly = (val) => {
    this.setState({ pipelineOnly: val });
  };

  _buildSubFilterFq = () => {
    const { activeTab, subFilters } = this.state;
    const fqParts = [];

    // Publication filter (articles tab)
    if (subFilters.publication) {
      fqParts.push(`(company_slugs:${subFilters.publication} OR event_tags:${subFilters.publication})`);
    }

    // Permit type filter (construction tab)
    if (subFilters.permitType) {
      fqParts.push(`event_tags:${subFilters.permitType}`);
    }

    // Permit status filter (construction tab)
    if (subFilters.permitStatus) {
      fqParts.push(`event_tags:${subFilters.permitStatus}`);
    }

    // Offering type filter
    if (subFilters.offeringType) {
      fqParts.push(`event_tags:${subFilters.offeringType}`);
    }

    // Offering status filter
    if (subFilters.offeringStatus) {
      fqParts.push(`event_tags:${subFilters.offeringStatus}`);
    }

    // Sale / Rent filter
    if (subFilters.eventType === "sale") {
      fqParts.push(`-event_tags:rent`);
    } else if (subFilters.eventType === "rent") {
      fqParts.push(`event_tags:rent`);
    }

    // Price change direction filter
    if (subFilters.changeType === "decrease") {
      fqParts.push(`event_tags:price-decrease`);
    } else if (subFilters.changeType === "increase") {
      fqParts.push(`event_tags:price-increase`);
    }

    return fqParts;
  };

  _getNews = async (reset) => {
    if (this.state.fetchInProgress === true) {
      return false;
    }
    this.setState({ fetchInProgress: true });
    if (reset) {
      this.setState({ data: [], start: 0, noMoreResults: false });
    }
    const { buildingRes, user, searchTags } = this.props;
    const { activeTab, pipelineOnly } = this.state;

    const fq = [
      this._getFqMap()[activeTab],
      "hierarchy:[0 TO 2]",
      `time:[* TO NOW]`,
      "-siblings:*",
    ];

    // Add sub-filter fq params
    const subFq = this._buildSubFilterFq();
    subFq.forEach((f) => fq.push(f));

    let q = "*:*";
    if (buildingRes) {
      const addressQ =
        buildingRes.address && buildingRes.address.alternate_addresses
          ? buildingRes.address.alternate_addresses
              .map((a) => a.toLowerCase())
              .join('" OR "')
          : false;

      q = `(full_street_address:("${addressQ}") AND (zip:${
        buildingRes.address.zip
      } OR borough:"${buildingRes.address.borough.toLowerCase()}"))`;
      if (
        buildingRes.building_slugs &&
        buildingRes.building_slugs.length > 0
      ) {
        q += ` OR building_slugs:(${buildingRes.building_slugs.join(" ")})`;
      }
    } else {
      // Build location query from searchTags
      let locQuery = _tranformTagsQuery(searchTags, "building");

      if (pipelineOnly) {
        let joinQuery = `pipeline_permit_source_id:* AND -pipeline_permit_source_id:"" AND deleted:false`;
        if (locQuery) {
          joinQuery += ` AND (${locQuery})`;
        }
        fq.push(
          `{!join from=key fromIndex=we3-buildings to=building}(${joinQuery})`
        );
      } else if (locQuery) {
        let joinQuery = `deleted:false AND (${locQuery})`;
        fq.push(
          `{!join from=key fromIndex=we3-buildings to=building}(${joinQuery})`
        );
      }
    }

    const axiosData = {
      url: apiURL + "we3-activities-3",
      method: "post",
      query: {
        q,
        fq,
        sort: "time desc",
        wt: "json",
        rows: this.state.rowsPerPage,
        start: reset ? 0 : this.state.start,
      },
    };

    const formattedData = await _axiosCall(axiosData)
      .then((res) => {
        if (res && res.docs && res.docs.length > 0) {
          this._getPipelineBuildings(res);
        } else if (res.docs.length === 0) {
          this.setState({ noMoreResults: true, fetchInProgress: false });
        }
      })
      .catch((error) => {
        console.log("error: " + error);
      });
    return formattedData;
  };

  _getPipelineBuildings = async (newsRes) => {
    if (!this.state.buildingsFetchInProgress) {
      this.setState((prevState) => ({ buildingsFetchInProgress: true }));
    }

    let searchFilters = [{ "meta.deleted": { $exists: false } }];

    let buildingKeys = [];
    if (newsRes && newsRes.docs && newsRes.docs.length > 0) {
      newsRes.docs.forEach((news) => {
        if (
          news.alternate_buildings &&
          Array.isArray(news.alternate_buildings)
        ) {
          buildingKeys = [...buildingKeys, ...news.alternate_buildings];
        } else if (news.building && Array.isArray(news.building)) {
          buildingKeys = [...buildingKeys, ...news.building];
        }
      });
    }
    if (buildingKeys.length > 0) {
      searchFilters.push({
        $or: [
          { building_key: { $in: buildingKeys } },
          { "address.key": { $in: buildingKeys } },
        ],
      });
    }

    let mongoQuery = {
      query: { $and: searchFilters },
      projection: {
        _id: 1,
        name: 1,
        display_full_street_address: 1,
        address: 1,
        key: 1,
        image: 1,
        images: 1,
        pipeline_zoning_area_residential: 1,
        pipeline_total_construction_floor_area: 1,
        pipeline_building_stories_proposed: 1,
        pipeline_dwelling_units_proposed: 1,
        pipeline_filing_date: 1,
        pipeline_pre_filing_date: 1,
        pipeline_project_stage: 1,
        pipeline_coo_issuance_date: 1,
        pipeline_permit_issuance_job_start_date: 1,
        pipeline_permit_issuance_filing_date: 1,
        occupancy_type: 1,
        pipeline_occupancy_type: 1,
        pipeline_project_components: 1,
        date_added: 1,
        pipeline_occupancy_classification_proposed_code: 1,
        building_key: 1,
      },
      limit: 99,
    };

    let axiosData = {
      url: buildingUrl + "query",
      method: "post",
      query: mongoQuery,
    };

    _axiosCall(axiosData)
      .then((res) => {
        let docs = [];
        if (res && res.docs) {
          docs = res.docs;
        }
        newsRes.docs.forEach((news) => {
          if (
            news.alternate_buildings &&
            Array.isArray(news.alternate_buildings)
          ) {
            news.alternate_buildings.forEach((blg) => {
              if (
                docs.filter(
                  (doc) =>
                    doc.building_key === blg ||
                    (doc.address && doc.address.key == blg)
                ).length > 0
              ) {
                news["pipeline_project"] = docs.filter(
                  (doc) =>
                    doc.building_key === blg ||
                    (doc.address && doc.address.key == blg)
                )[0];
              }
            });
          } else if (news.building && Array.isArray(news.building)) {
            news.building.forEach((blg) => {
              if (
                docs.filter(
                  (doc) =>
                    doc.building_key === blg ||
                    (doc.address && doc.address.key == blg)
                ).length > 0
              ) {
                news["pipeline_project"] = docs.filter(
                  (doc) =>
                    doc.building_key === blg ||
                    (doc.address && doc.address.key == blg)
                )[0];
              }
            });
          }
        });
        this.setState({
          data: [...this.state.data, ...newsRes.docs],
          fetchInProgress: false,
          buildingsFetchInProgress: false,
        });
      })
      .catch((error) => {
        console.log("error: " + error);
      });
  };

  render() {
    const { buildingRes, searchTags } = this.props;
    const { data, fetchInProgress, activeTab, subFilters, pipelineOnly } =
      this.state;
    if (!data) {
      return null;
    }

    const tabsAndContent = (
      <Fragment>
        <div
          className={`tabs ${
            !buildingRes ? "tabs--bordered-bottom" : ""
          }`}
          style={!buildingRes ? { marginTop: 20 } : {}}
        >
          <div className="tabs__wrap">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "summary",
                  })}
                  onClick={() => {
                    this._setActiveTab("summary");
                  }}
                >
                  <span className="tab-title">Summary</span>
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "articles",
                  })}
                  onClick={() => {
                    this._setActiveTab("articles");
                  }}
                >
                  <span className="tab-title">Articles</span>
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "construction",
                  })}
                  onClick={() => {
                    this._setActiveTab("construction");
                  }}
                >
                  <span className="tab-title">Construction</span>
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "offering-plans",
                  })}
                  onClick={() => {
                    this._setActiveTab("offering-plans");
                  }}
                >
                  <span className="tab-title">Offering Plans</span>
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "listings",
                  })}
                  onClick={() => {
                    this._setActiveTab("listings");
                  }}
                >
                  <span className="tab-title">Listings</span>
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "contracts",
                  })}
                  onClick={() => {
                    this._setActiveTab("contracts");
                  }}
                >
                  <span className="tab-title">Contracts</span>
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "sales",
                  })}
                  onClick={() => {
                    this._setActiveTab("sales");
                  }}
                >
                  <span className="tab-title">Sales</span>
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "price-changes",
                  })}
                  onClick={() => {
                    this._setActiveTab("price-changes");
                  }}
                >
                  <span className="tab-title">Price Changes</span>
                </NavLink>
              </NavItem>
            </Nav>
          </div>
          <SubTopicFilters
            activeTab={activeTab}
            subFilters={subFilters}
            setSubFilter={this._setSubFilter}
            pipelineOnly={pipelineOnly}
            setPipelineOnly={this._setPipelineOnly}
            buildingRes={buildingRes}
          />
        </div>

        {fetchInProgress && data.length <= 0 ? (
          <div style={{ padding: "20px" }}>
            <LinearLoading />
          </div>
        ) : !fetchInProgress && data.length <= 0 ? (
          <div className={`email-confirmation`}>
            <div className="email-confirmation__icon">
              <AlertIcon size={50} color={`#D6BAE8`} />
            </div>
            <h3 className="email-confirmation__title">No News Yet</h3>
            <p className="email-confirmation__sub">
              Marketproof Pipeline is connecting buildings with news daily,
              check back soon.
            </p>
          </div>
        ) : (
          <Fragment>
            <div className="timeline">
              {data.map((item) => {
                try {
                  const data = JSON.parse(item.data);
                  item.data = data;
                } catch (e) {
                  //ToDo
                }

                return <NewsItem item={item} />;
              })}
            </div>
            <div className="timeline_load">
              <Tooltip title="Load more news">
                <Button
                  onClick={(e) => {
                    this._loadMore(e);
                  }}
                  variant="contained"
                  color="news"
                  className={`timeline__load-more`}
                  startIcon={<LoadMoreIcon />}
                  disabled={
                    this.state.fetchInProgress || this.state.noMoreResults
                  }
                >
                  {" "}
                  {`${
                    this.state.fetchInProgress
                      ? "Loading..."
                      : this.state.noMoreResults
                      ? "That's All The News"
                      : "Load More"
                  }`}
                </Button>
              </Tooltip>
            </div>
          </Fragment>
        )}
      </Fragment>
    );

    return (
      <Col md={12}>
        {!buildingRes ? (
          <Card>
            <CardBody style={{ padding: 0 }}>
              <div className="news-search-bar-only">
                <BuildingSearchAppBar
                  handleSearch={() => {}}
                  subFilters={{}}
                  setSubFilter={() => {}}
                  resetSubFilter={() => {}}
                  _filters={[]}
                  buildingStages={[]}
                  setBuildingStage={() => {}}
                  placeHolder={"Borough, Neighborhood or Building"}
                  buildingFilter={`pipeline_permit_source_id:* AND -pipeline_permit_source_id:"" AND deleted:false`}
                />
              </div>
              <div style={{ padding: "0 20px 20px" }}>
                {tabsAndContent}
              </div>
            </CardBody>
          </Card>
        ) : (
          tabsAndContent
        )}
      </Col>
    );
  }
}

function mapStateToProps(state) {
  return {
    searchTags: Array.isArray(state.search.searchTags)
      ? state.search.searchTags.slice()
      : [],
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(searchActions, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TimelineHistory));
